import { render, staticRenderFns } from "./questionRepeat.vue?vue&type=template&id=71176bc5&scoped=true&"
import script from "./questionRepeat.vue?vue&type=script&lang=js&"
export * from "./questionRepeat.vue?vue&type=script&lang=js&"
import style0 from "./questionRepeat.vue?vue&type=style&index=0&id=71176bc5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71176bc5",
  null
  
)

export default component.exports